import styled from 'styled-components';
import { getUrlWithToken } from '../../../../utils/common';

export const StyledCourseHero = styled.div.withConfig({
  shouldForwardProp: (prop) => !['cover'].includes(prop),
})`
  background-color: ${({ theme }) => theme.colors.themeColor};
  background-image: url(${({ cover }) => getUrlWithToken(cover)});
  background-size: cover;
  background-position: center center;
  width: 100%;
  height: fit-content;
  position: relative;
`;

export const Shadow = styled.div`
  height: fit-content;
  width: 100%;
  background: linear-gradient(
    180deg,
    rgba(192, 192, 192, 0.38) -56.08%,
    rgba(0, 0, 0, 0.71) 100%
  );
`;

export const Overlay = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  color: ${({ theme }) => theme.colors.white};
  width: 100%;
  min-height: 393px;
  padding-block: 32px;
`;

export const TitleBlock = styled.div`
  margin-bottom: 40px;

  .course-title {
    max-width: 90%;
  }

  /* badge */
  > div:first-child {
    margin-bottom: 24px;
  }
`;

export const Overtitle = styled.div`
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  text-transform: uppercase;
  margin-bottom: 16px;

  > span {
    &::after {
      content: ' - ';
    }

    &:last-child::after {
      display: none;
    }
  }
`;

export const Inline = styled.div`
  display: flex;
  align-items: center;
  column-gap: 12px;

  span {
    color: #d1d1d1;
  }
`;

export const ProgressBlock = styled.div`
  max-width: 500px;
  margin-bottom: 32px;

  svg {
    margin-left: 6px;
    stroke: ${({ theme }) => theme.colors.white};
  }
`;

export const ProgressInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;

  @media ${(props) => props.theme.device.mobileL} {
    margin-bottom: 48px;
  }
`;

export const ProgressNumber = styled.div`
  margin-bottom: -4px;

  @media ${(props) => props.theme.device.mobileL} {
    margin-bottom: -92px;
  }
`;

export const BadgeCtaBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media ${(props) => props.theme.device.mobileL} {
    flex-direction: column;
    row-gap: 40px;
  }
`;

export const BadgeContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 20px;
  width: 100%;
  max-width: 500px;

  /* inner container */
  > div {
    display: flex;
    align-items: center;
    column-gap: 40px;
  }

  @media ${(props) => props.theme.device.mobileL} {
    flex-wrap: wrap;
    justify-content: start;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 32px;
  margin-left: 20px;

  @media ${(props) => props.theme.device.laptop} {
    flex-flow: row;
    width: 100%;
    flex-wrap: wrap;
    justify-content: flex-end;
    div {
      width: 100%;
      text-align: right;
    }
  }

  @media ${(props) => props.theme.device.mobileL} {
    flex-flow: column-reverse;
    row-gap: 8px;
    width: 100%;
    margin-left: 0;

    div {
      text-align: center;
    }

    a {
      display: block;
      width: 100%;
    }
  }

  .btn-recommend {
    &.recommended svg {
      fill: ${(props) => props.theme.colors.link} !important;
    }
  }
`;
